import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import EmailIcon from 'mdi-react/EmailIcon';
import CheckboxMarkedCircleIcon from 'mdi-react/CheckboxMarkedCircleIcon';

const UploadConfirmationCard = () => (
  <Col md={12}>
    <br />
    <br />
    <br />
    <Card>
      <CardBody>
        <div className="email-confirmation">
          <div className="email-confirmation__icon">
            <EmailIcon className="email-confirmation__mail" />
            <CheckboxMarkedCircleIcon className="email-confirmation__check" />
          </div>
          <h3 className="email-confirmation__title">We&apos;ve received your information!</h3>
          <p className="email-confirmation__sub">You will receive an email over the next few days once verified</p>
        </div>
      </CardBody>
    </Card>
  </Col>
);

export default UploadConfirmationCard;
